import React, { useEffect, useState } from 'react';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import { useHealthPlansQuery } from '../../../../graphql/graphql';
import { FieldError } from 'react-hook-form';
import MultiSelect from '../../../../Components/Base/MultiSelect/MultiSelect';
import Loading from '../../../../Components/Loading';

interface Props {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
	error?: FieldError;
}

const HealthPlanMultiSelect: React.FC<Props> = props => {
	const { value, onChange } = props;
	const { data, isLoading } = useHealthPlansQuery();
	const [options, setOptions] = useState<SelectValue[]>();
	const [defaultValue, setDefaultValue] = useState(value);
	const healthPlans = data?.healthPlans;

	useEffect(() => {
		const items: SelectValue[] = [];
		for (const healthPlan of healthPlans?.data || []) {
			if (healthPlan) {
				items.push({
					value: healthPlan.id,
					label: healthPlan.name || '',
				});
			}
		}
		setOptions(items);
	}, [healthPlans]);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<MultiSelect
			options={options}
			{...props}
			onChange={onChange}
			value={defaultValue?.label ? defaultValue : value}
		/>
	);
};

export default HealthPlanMultiSelect;
